import { API_CONFIG, API_ENDPOINTS, authFetch, getHeadersWithOrg } from './client';

/**
 * Region templates (e.g. `left-toc.j2`) are served by the publishing/kg service
 * as raw template source — the SAME `.j2` source the publish path renders via
 * Jinja2 — so the editor renders them via nunjucks for parity by construction.
 * Like every kg endpoint it lives under the `/flameback/api/v1` prefix and uses
 * the same base URL the component catalog uses.
 */
const REGION_TEMPLATES_PATH = API_ENDPOINTS.REGION_TEMPLATES;

/** One region template: a stable `id` and its raw template `source`. */
export interface RegionTemplateItem {
  id: string;
  source: string;
}

/**
 * Fetch the region template sources from the publishing/kg service.
 *
 * The set is static for a session (built-in region templates, not per-site
 * data), so callers cache the result. A non-OK status throws; the caller
 * degrades to an empty list.
 */
export async function getRegionTemplates(): Promise<RegionTemplateItem[]> {
  const response = await authFetch(
    `${API_CONFIG.BASE_URL}${REGION_TEMPLATES_PATH}`,
    { headers: getHeadersWithOrg() },
  );
  if (!response.ok) {
    throw new Error(`Failed to load region templates: ${response.status}`);
  }
  return (await response.json()) as RegionTemplateItem[];
}
